//import axios          from "axios";
//import { api }        from "../_constants";
//import handleResponse from "./handleResponse";
//import getVoucherUser from "./handleVoucherUser";
//import getVoucherData from "./handleVoucherData";

export const wu_Utilities = {
  printSomeValuesFromLocalStorage,
  LogoutUserFromApp,
  clearTransaction,
  getNavigationURLs,
  checkIfUserIsLoggedIn,
  update_uilatstats,
  check_uilatstats,
  wu_verifyEmail,
  wu_verifyMTCN,
  offline_validate_numericCharacters,
  offline_validate_latinCharacters,
  offline_validate_latinAlphaNumeric,
  offline_validate_firstName,
  offline_validate_lastName,
  offline_validate_homeAddress,
  offline_validate_cityResidence,
  offline_validate_birthCity,
  offline_validate_phone,
  offline_validate_phone_landline,
  offline_validate_phone_mobile,
  offline_validate_phone_international,
  offline_validate_6digitforgotpasspin,
  offline_validate_8digitregisterpin,
  convert2FloatString,
  validateFloatString,
  offline_validate_securityQuestion,
  offline_validate_securityAnswer,
  userHasSetPDF_memory,
  addStars,
  findCountryIdFromCountryName,
  findCountryNameFromCountryId,
  findCountryObjFromCountryId,
  findCountryIndexFromCountryId,
  findCurrencyNameFromCurrencyId,
  findPhonePrefixNameFromPhonePrefixId,
  findPhonePrefixObjFromPhonePrefixId,
  findProfessionNameFromProfessionId,
  findPositionlevelNameFromPositionlevelId,
  findLanguageNameFromLanguageId,
//wu_removeGreekCharacters,
  shouldForceRefreshAccessToken,
  normalizePhoneCountryName,
  extractKeywordsFromJSON,
  replaceTonoumena,
  timetableFiltering,
  registration_telephone_get,
  registration_telephone_set,
  findBankIdFromBankName,
  findBankPhotoFromBankName,
  campaign_clear_statsView,
  campaign_should_show,
  campaign_record_load,
  newRegistrationFlow_flag_get,
  textDecisions_SettingsProfileId,
  textDecisions_customerLevel,
  bills_normalizeAmount,
  bills_amount_with_comma,
  bills_status_text,
  bills_status_isDone,
  bills_isRepeatable,
  bills_shouldBeInCategoriesListing,
  bills_isTransactionFavorite_historyDetail,
  bills_images_urls,
  bills_getFriendlyDate,
  bills_companyNameFromBillId,
  bills_companyKeywordsFromBillId,
  bills_companyObjectFromBillId,
  bills_categoryExists,
  bills_getPaymentAmount,
  bills_getPaymentFees,
  bills_history_getEndDate,
  bills_history_getStartDate,
  triggerRefreshCheck,
  addKeywordsToJSON_test,
  diffDatesSec,
};

export const campaign_active4Controllers = [
  "payLinkWepApp"
// "LoginPage",
// "HistoryList",
// "HistoryDetail",
// "HistoryChange",
// "HistoryRefund",
// "TransferOnline1",
// "TransferOnline2",
// "TransferOnlineCards"
// "TransferOnline3",
// "TransferOnlineLogin",
// "TransferOnline4b",
// "TransferOnline4c",
// "TransferOnline4c2",
// "TransferOnline4c3",
// "ForgotPass1",
// "ForgotPass2",
// "ForgotPass3",
// "TrackTransfer",
// "StoreLocator",
// "SettingsMain",
// "SettingsChangePass",
// "SettingsChangeMobile",
// "SettingsProfileIdDetails",
// "SettingsProfilePersonal",
// "SettingsHelp",
// "SettingsPrivacy",
// "SettingsTerms",
// "SettingsTermsBills",
// "SettingsProfile1",
// "SettingsProfile2",
// "SettingsProfile3",
// "ScanDocuments",
// "CustomerConfirm"
// "RegisterLight1",
// "RegisterLight1OTP",
// "RegisterLight1Login",
// "RegisterLightInfo",
// "RegisterLight2",
// "RegisterLight2BP",
// "RegisterLight3",
// "RegisterLight4",
// "RegisterLight5IdBoxInfo",
// "RegisterLightEndBP"
// "RegisterLightStore"
// "RegisterIdBoxSuccess",
// "Bills",
// "BillsCategories",
// "BillsCompanies",
// "Scanner",
// "BillsHistory",
// "BillsHistoryDetail",
// "BillsFavorites",
// "BillsFavoritesDetail",
// "BillsPaymentSetup",
// "BillsPaymentReview",
// "cardList",
];
//----------------------------------------------------------------------------------------------------
function printSomeValuesFromLocalStorage() {
  console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
  console.log("printSomeValuesFromLocalStorage");
  console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
  console.log("HTTP_user                             = "+localStorage.getItem("HTTP_user"));
  console.log("birthYear                             = "+localStorage.getItem("birthYear"));
  console.log("isLoggedIn                            = "+localStorage.getItem("isLoggedIn"));
  console.log("tokenID                               = "+localStorage.getItem("tokenID"));
  console.log("accessToken                           = "+localStorage.getItem("accessToken"));
  console.log("refreshToken                          = "+localStorage.getItem("refreshToken"));
  console.log("TransferOnline1_type                  = "+localStorage.getItem("TransferOnline1_type"));
  console.log("TransferOnline1_PaymentMethod         = "+localStorage.getItem("TransferOnline1_PaymentMethod"));
  console.log("TransferOnline1_TransferMethod        = "+localStorage.getItem("TransferOnline1_TransferMethod"));
  console.log("TransferOnline1_PaymentMethod_str     = "+localStorage.getItem("TransferOnline1_PaymentMethod_str"));
  console.log("TransferOnline1_TransferMethod_str    = "+localStorage.getItem("TransferOnline1_TransferMethod_str"));
  console.log("TransferOnline1_amountToSend          = "+localStorage.getItem("TransferOnline1_amountToSend"));
  console.log("TransferOnline1_amountToReceive       = "+localStorage.getItem("TransferOnline1_amountToReceive"));
  console.log("TransferOnline1_selCountry            = "+localStorage.getItem("TransferOnline1_selCountry"));
  console.log("TransferOnline1_selCountry_ctry_wu_id = "+localStorage.getItem("TransferOnline1_selCountry_ctry_wu_id"));
  console.log("TransferOnline1_selState              = "+localStorage.getItem("TransferOnline1_selState"));
  console.log("TransferOnline1_selCity               = "+localStorage.getItem("TransferOnline1_selCity"));
  console.log("TransferOnline1_selCurrencyOrig       = "+localStorage.getItem("TransferOnline1_selCurrencyOrig"));
  console.log("TransferOnline1_selCurrencyDest       = "+localStorage.getItem("TransferOnline1_selCurrencyDest"));
}
//----------------------------------------------------------------------------------------------------
function LogoutUserFromApp(fromController) {
  console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
  console.log("LogoutUserFromApp fromController="+fromController);
  console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
  localStorage.setItem("HTTP_user",                                      "");
  localStorage.setItem("birthYear",                                      "");
  localStorage.setItem("isLoggedIn",                                     "false");
  localStorage.setItem("tokenID",                                        "");
  localStorage.setItem("accessToken",                                    "");
  localStorage.setItem("refreshToken",                                   "");
  localStorage.setItem("user",                                           {});

  localStorage.setItem("parserObject_omtregistrationFull_req",           "");

  localStorage.setItem("TransferOnline1_type",                           "");
  localStorage.setItem("TransferOnline1_type",                           "");
  localStorage.setItem("TransferOnline1_PaymentMethod",                  "");
  localStorage.setItem("TransferOnline1_TransferMethod",                 "");
  localStorage.setItem("TransferOnline1_PaymentMethod_str",              "");
  localStorage.setItem("TransferOnline1_TransferMethod_str",             "");
  localStorage.setItem("TransferOnline1_amountToSend",                   "");
  localStorage.setItem("TransferOnline1_amountToReceive",                "");
  localStorage.setItem("TransferOnline1_selCountry",                     "");
  localStorage.setItem("TransferOnline1_selCountry_ctry_wu_id",          "");
  localStorage.setItem("TransferOnline1_selState",                       "");
  localStorage.setItem("TransferOnline1_selCity",                        "");
  localStorage.setItem("TransferOnline1_selCurrencyOrig",                "");
  localStorage.setItem("TransferOnline1_selCurrencyDest",                "");

  localStorage.setItem("promo_type_selected",                            "");

  localStorage.setItem("parserObject_validatecustomer",                  "");
  localStorage.setItem("parserObject_checkuploadedID",                   "");

  localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    "");
  localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", "");
  localStorage.setItem("parserObject_validateoutbound_req",              "");
  localStorage.setItem("parserObject_validateoutbound",                  "");
  localStorage.setItem("parserObject_validateoutbound_d2b_req",          "");
  localStorage.setItem("parserObject_validateoutbound_d2b",              "");
  localStorage.setItem("parserObject_sendoutbound_req",                  "");
  localStorage.setItem("parserObject_sendoutbound",                      "");
  localStorage.setItem("parserObject_sendoutbound_d2b_req",              "");
  localStorage.setItem("parserObject_sendoutbound_d2b",                  "");
  localStorage.setItem("parserObject_cardpaymentticket",                 "");
  localStorage.setItem("parserObject_finalizeoutbound",                  "");
  localStorage.setItem("parserObject_finalizeoutbound_req",              "");

  localStorage.setItem("parserObject_getd2bfields_JSON",                 "");
  localStorage.setItem("parserObject_sendoutbound_capitalcontrols",      "");
  localStorage.setItem("parserObject_sendoutbound_d2b_capitalcontrols",  "");
  localStorage.setItem("finalizeoutbound_type",                          "");

  //Do nothing if
  localStorage.setItem("TransferOnline1","");
  localStorage.setItem("TransferOnline2","");
  localStorage.setItem("TransferOnlineCards","");

  localStorage.setItem("omtregistrationFull_req_telephone","");
}
//----------------------------------------------------------------------------------------------------
function clearTransaction() {

  localStorage.setItem("TransferOnline1_type",                           "");
  localStorage.setItem("TransferOnline1_type",                           "");
  localStorage.setItem("TransferOnline1_PaymentMethod",                  "");
  localStorage.setItem("TransferOnline1_TransferMethod",                 "");
  localStorage.setItem("TransferOnline1_PaymentMethod_str",              "");
  localStorage.setItem("TransferOnline1_TransferMethod_str",             "");
  localStorage.setItem("TransferOnline1_amountToSend",                   "");
  localStorage.setItem("TransferOnline1_amountToReceive",                "");
  localStorage.setItem("TransferOnline1_selCountry",                     "");
  localStorage.setItem("TransferOnline1_selCountry_ctry_wu_id",          "");
  localStorage.setItem("TransferOnline1_selState",                       "");
  localStorage.setItem("TransferOnline1_selCity",                        "");
  localStorage.setItem("TransferOnline1_selCurrencyOrig",                "");
  localStorage.setItem("TransferOnline1_selCurrencyDest",                "");

  localStorage.setItem("promo_type_selected",                            "");

  localStorage.setItem("parserObject_checkuploadedID",                   "");

  localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    "");
  localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", "");
  localStorage.setItem("parserObject_validateoutbound_req",              "");
  localStorage.setItem("parserObject_validateoutbound",                  "");
  localStorage.setItem("parserObject_validateoutbound_d2b_req",          "");
  localStorage.setItem("parserObject_validateoutbound_d2b",              "");
  localStorage.setItem("parserObject_sendoutbound_req",                  "");
  localStorage.setItem("parserObject_sendoutbound",                      "");
  localStorage.setItem("parserObject_sendoutbound_d2b_req",              "");
  localStorage.setItem("parserObject_sendoutbound_d2b",                  "");
  localStorage.setItem("parserObject_cardpaymentticket",                 "");
  localStorage.setItem("parserObject_finalizeoutbound",                  "");
  localStorage.setItem("parserObject_finalizeoutbound_req",              "");

  localStorage.setItem("parserObject_getd2bfields_JSON",                 "");
  localStorage.setItem("parserObject_sendoutbound_capitalcontrols",      "");
  localStorage.setItem("parserObject_sendoutbound_d2b_capitalcontrols",  "");
  localStorage.setItem("finalizeoutbound_type",                          "");
}
//----------------------------------------------------------------------------------------------------
function getNavigationURLs(value) {
  let api_webapp_path = "/onlinemt";

  let api_webapp_path_ls = localStorage.getItem("api_webapp_path");
  api_webapp_path = (api_webapp_path_ls===null || (typeof api_webapp_path_ls==="undefined") || api_webapp_path_ls==="") ? "/onlinemt" : api_webapp_path_ls;
  //-----
  //Login
  //-----
       if(value==="LoginPage")                   { return api_webapp_path+"/auth";}
  //-------
  //History
  //-------
  else if(value==="HistoryList")                 { return api_webapp_path+"/HistoryList";}
  else if(value==="HistoryDetail")               { return api_webapp_path+"/HistoryDetail";}
  else if(value==="HistoryChange")               { return api_webapp_path+"/HistoryChange";}
  else if(value==="HistoryRefund")               { return api_webapp_path+"/HistoryRefund";}
  //--------------
  //TransferOnline
  //--------------
  else if(value==="TransferOnline1")             { return api_webapp_path+"/TransferOnline1";}
  else if(value==="TransferOnline2")             { return api_webapp_path+"/TransferOnline2";}
  else if(value==="TransferOnlineCards")         { return api_webapp_path+"/TransferOnlineCards";}
  else if(value==="TransferOnline3")             { return api_webapp_path+"/TransferOnline3";}
  else if(value==="TransferOnlineLogin")         { return api_webapp_path+"/TransferOnlineLogin";}
  else if(value==="TransferOnline4b")            { return api_webapp_path+"/TransferOnline4b";}
  else if(value==="TransferOnline4c")            { return api_webapp_path+"/TransferOnline4c";}
  else if(value==="TransferOnline4c2")           { return api_webapp_path+"/TransferOnline4c2";}
  else if(value==="TransferOnline4c3")           { return api_webapp_path+"/TransferOnline4c3";}
  //----------
  //ForgotPass
  //----------
  else if(value==="ForgotPass1")                 { return api_webapp_path+"/ForgotPass1";}
  else if(value==="ForgotPass2")                 { return api_webapp_path+"/ForgotPass2";}
  else if(value==="ForgotPass3")                 { return api_webapp_path+"/ForgotPass3";}
  //--------------
  //Register Light
  //--------------
  else if(value==="RegisterLight1")              { return api_webapp_path+"/RegisterLight1";}
  else if(value==="RegisterLight1OTP")           { return api_webapp_path+"/RegisterLight1OTP";}
  else if(value==="RegisterLight1Login")         { return api_webapp_path+"/RegisterLight1Login";}
  else if(value==="RegisterLightInfo")           { return api_webapp_path+"/RegisterLightInfo";}
  else if(value==="RegisterLight2")              { return api_webapp_path+"/RegisterLight2";}
  else if(value==="RegisterLight2BP")            { return api_webapp_path+"/RegisterLight2BP";}
  else if(value==="RegisterLight3")              { return api_webapp_path+"/RegisterLight3";}
  else if(value==="RegisterLight4")              { return api_webapp_path+"/RegisterLight4";}
  else if(value==="RegisterLight5IdBoxInfo")     { return api_webapp_path+"/RegisterLight5IdBoxInfo";}
  else if(value==="RegisterIdBoxSuccess")        { return api_webapp_path+"/RegisterIdBoxSuccess";}
  else if(value==="RegisterLightEndBP")          { return api_webapp_path+"/RegisterLightEndBP";}
  else if(value==="RegisterLightStore")          { return api_webapp_path+"/RegisterLightStore";}
  //-------------
  //TrackTransfer
  //-------------
  else if(value==="TrackTransfer")               { return api_webapp_path+"/TrackTransfer";}
  //------------
  //StoreLocator
  //-------------
  else if(value==="StoreLocator")                { return api_webapp_path+"/StoreLocator";}
  //----------------
  //Settings/Profile
  //----------------
  else if(value==="SettingsMain")                { return api_webapp_path+"/SettingsMain";}
  else if(value==="SettingsChangePass")          { return api_webapp_path+"/SettingsChangePass";}
  else if(value==="SettingsChangeMobile")        { return api_webapp_path+"/SettingsChangeMobile";}
  else if(value==="SettingsProfileIdDetails")    { return api_webapp_path+"/SettingsProfileIdDetails";}
  else if(value==="SettingsProfilePersonal")     { return api_webapp_path+"/SettingsProfilePersonal";}
  else if(value==="SettingsHelp")                { return api_webapp_path+"/SettingsHelp";}
  else if(value==="SettingsPrivacy")             { return api_webapp_path+"/SettingsPrivacy";}
  else if(value==="SettingsTerms")               { return api_webapp_path+"/SettingsTerms";}
  else if(value==="SettingsTermsBills")          { return api_webapp_path+"/SettingsTermsBills";}
  else if(value==="SettingsProfile1")            { return api_webapp_path+"/SettingsProfile1";}
  else if(value==="SettingsProfile2")            { return api_webapp_path+"/SettingsProfile2";}
  else if(value==="SettingsProfile3")            { return api_webapp_path+"/SettingsProfile3";}
  //-------------
  //ScanDocuments
  //-------------
  // else if(value==="ScanDocuments")               { return api_webapp_path+"/ScanDocuments";}
  //---------------
  //CustomerConfirm
  //---------------
  else if(value==="CustomerConfirm")             { return api_webapp_path+"/CustomerConfirm";}
  //-----
  //Bills
  //-----
  else if(value==="Bills")                       { return api_webapp_path+"/Bills";}
  else if(value==="BillsCategories")             { return api_webapp_path+"/BillsCategories";}
  else if(value==="BillsCompanies")              { return api_webapp_path+"/BillsCompanies";}
  else if(value==="BillsScanner")                { return api_webapp_path+"/BillsScanner";}
  else if(value==="BillsHistory")                { return api_webapp_path+"/BillsHistory";}
  else if(value==="BillsHistoryDetail")          { return api_webapp_path+"/BillsHistoryDetail";}
  else if(value==="BillsFavorites")              { return api_webapp_path+"/BillsFavorites";}
  else if(value==="BillsFavoritesDetail")        { return api_webapp_path+"/BillsFavoritesDetail";}
  else if(value==="BillsPaymentSetup")           { return api_webapp_path+"/BillsPaymentSetup";}
  else if(value==="BillsPaymentReview")          { return api_webapp_path+"/BillsPaymentReview";}
  //----
  //More
  //----
  else if(value==="More")                        { return api_webapp_path+"/More";}
  //----
  //Card
  //----
  else if(value==="CardList")                    { return api_webapp_path+"/CardList";}

  return api_webapp_path+"/auth";
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function update_uilatstats() {
  //const methName = "update_uilatstats ";
  if(localStorage.getItem("uilatstats_curr")===null){
    localStorage.setItem("uilatstats_curr", new Date());
  }
  localStorage.setItem("uilatstats_prev", localStorage.getItem("uilatstats_curr"));
  localStorage.setItem("uilatstats_curr", new Date());
  //console.log(methName+'uilatstats_curr='+localStorage.getItem("uilatstats_curr"));
  //console.log(methName+'uilatstats_prev='+localStorage.getItem("uilatstats_prev"));
}
//----------------------------------------------------------------------------------------------------
function check_uilatstats(uilatstats_inactivity_mins) {
  const methName = "check_uilatstats ";
  try{
    const date1 = new Date(localStorage.getItem("uilatstats_curr"));
    const date2 = new Date(localStorage.getItem("uilatstats_prev"));
    const diffTime  = Math.abs(date2 - date1);
  //const diffDays  = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  //const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
    const diffMins  = Math.ceil(diffTime / (1000 * 60));
    //XXX//console.log(methName+'diffMins='+diffMins + "/" + uilatstats_inactivity_mins);
    if(diffMins < uilatstats_inactivity_mins){
      return true;
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return false;
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function checkIfUserIsLoggedIn(value) {
  if(localStorage.getItem("isLoggedIn")==="true"){
    return true;
  }
  return false;
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function wu_verifyEmail(value) {
  var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
}
//----------------------------------------------------------------------------------------------------
function wu_verifyMTCN(candidate) {
  var aRex = /[0-9]{10,10}/;
  if (aRex.test(candidate)) { return true; }
  return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_numericCharacters(candidate){
    var aRex = /^[0-9]+([\\s][0-9]+)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_latinCharacters(candidate){
    var aRex = /^[a-zA-Z]+([\\s][a-zA-Z]+)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_latinAlphaNumeric(candidate){
    var aRex = /^[a-zA-Z0-9]+([\\s][a-zA-Z0-9]+)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_firstName(candidate){
    var aRex = /^[a-zA-Z]+([\\s][a-zA-Z]+)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_lastName(candidate){
    var aRex = /^[a-zA-Z]+([\\s]?[\\.,-]?[\\s]?[\\.,-]?[a-zA-Z]+)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_homeAddress(candidate){
    var aRex = /^[a-zA-Z0-9]+([\\s]?[\\.,-]?[\\s]?[\\.,-]?[a-zA-Z0-9]+[\\s]?)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_cityResidence(candidate){
    var aRex = /^[a-zA-Z]+([\\s]?[\\.,-]?[\\s]?[\\.,-]?[a-zA-Z]+)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_birthCity(candidate){
    var aRex = /^[a-zA-Z]+([\\s]?[\\.,-]?[\\s]?[\\.,-]?[a-zA-Z]+)*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_phone(candidate){
    var aRex = /^(2\\d{9})|(69\\d{8})|(00\\d{8,})$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_phone_landline(candidate){
  //var aRex = /^(2\\d{9})*$/;
    var aRex = /^(2[0-9]{9})*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_phone_mobile(candidate){
  //var aRex = /^(69\\d{8})*$/;
    var aRex = /^(69[0-9]{8})*$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_phone_international(candidate){
    var aRex = /^((\\+)|(00))[0-9]{6,14}$/;
    if (aRex.test(candidate)) { return true; }
    return false;
}
//----------------------------------------------------------------------------------------------------
function offline_validate_6digitforgotpasspin(candidate) {
    var myRegex = /[0-9]{6,6}/;
    if (myRegex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_8digitregisterpin(candidate) {
    var myRegex = /[0-9]{8,8}/;
    if (myRegex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------------------------------
function convert2FloatString(inputStr){
  if(inputStr===null || (inputStr ==="")){return "";}
  inputStr = inputStr.replace("," , ".")
  if(inputStr.indexOf(".")<0){
    inputStr = inputStr+".00";
  }
  return inputStr;
}
//-------------------------------------------------------------------------------------------------------------------------------
function validateFloatString(inputStr){
  //var aRex = /^(?:|0|[1-9]\\d*)(?:\\.\\d*)?$/;
    var aRex = /^[+-]?\d+(\.\d+)?$/;
    if (aRex.test(inputStr)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_securityQuestion(candidate){
    var myRegex = /^[a-zA-Z\\?]+([\\s][a-zA-Z\\?]+)*$/;
    if (myRegex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function offline_validate_securityAnswer(candidate){
    var myRegex = /^[a-zA-Z]+([\\s][a-zA-Z]+)*$/;
    if (myRegex.test(candidate)) { return true; }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function userHasSetPDF_memory(){

    let userHasSetPDF = false;
    if(localStorage.getItem("ScanDocuments_items_num")==="1"){
        userHasSetPDF = (localStorage.getItem("ScanDocuments_img_ONE_image1")===null) ? false : true;
    }
    else if(localStorage.getItem("ScanDocuments_items_num")==="1"){
        userHasSetPDF = (localStorage.getItem("ScanDocuments_img_TWO_image1")===null || localStorage.getItem("ScanDocuments_img_TWO_image2")===null) ? false : true;
    }

    return userHasSetPDF;
}
//-------------------------------------------------------------------------------------------------------------------------------
function addStars(inpt){

    if(inpt === null || (typeof inpt === "undefined")){
        return "";
    }

    if(inpt.length>4){
        return inpt.substring(0, 4)+"*****";
    }
    return inpt;
}
//----------------------------------------------------------------------------------------------------
function findCountryIdFromCountryName(ctry_name) {
  const methName = "findCountryIdFromCountryName ";
  try{
    let countries = [];
    try { countries = JSON.parse(localStorage.getItem("countries")); }catch(err){;}
    if(countries===null || (typeof countries === "undefined")){
      return "";
    }

    //console.log(methName+'ctry_name='+ctry_name+",countries.countries.length="+countries.countries.length);
    for(let i=0; countries.countries && i<countries.countries.length; ++i){
      if(countries.countries[i].descr_en===ctry_name || countries.countries[i].descr_el===ctry_name || (countries.countries[i].Keywords && countries.countries[i].Keywords.indexOf(ctry_name))>-1 ){
        return countries.countries[i]["ctry_wu_id"];
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function findCountryNameFromCountryId(ctry_wu_id,lang) {
  const methName = "findCountryNameFromCountryId ";
  try{
    let countries = [];
    try { countries = JSON.parse(localStorage.getItem("countries")); }catch(err){;}
    if(countries===null || (typeof countries === "undefined")){
      return "";
    }

    //console.log(methName+'ctry_wu_id='+ctry_wu_id+",lang="+lang+",countries.countries.length="+countries.countries.length);
    for(let i=0; countries.countries && i<countries.countries.length; ++i){
      if(countries.countries[i].ctry_wu_id===ctry_wu_id){
        if(lang==="en"){ return countries.countries[i]["descr_en"];}
        else           { return countries.countries[i]["descr_el"];}
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function findCountryObjFromCountryId(ctry_wu_id,lang) {
  const methName = "findCountryObjFromCountryId ";
  try{
    let countries = [];
    try { countries = JSON.parse(localStorage.getItem("countries")); }catch(err){;}
    if(countries===null || (typeof countries === "undefined")){
      return {};
    }

    //console.log(methName+'ctry_wu_id='+ctry_wu_id+",lang="+lang+",countries.countries.length="+countries.countries.length);
    for(let i=0; countries.countries && i<countries.countries.length; ++i){
      if(countries.countries[i].ctry_wu_id===ctry_wu_id){
        if(lang==="en"){ return countries.countries[i];}
        else           { return countries.countries[i];}
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return {};
}
//----------------------------------------------------------------------------------------------------
function findCountryIndexFromCountryId(ctry_wu_id,lang,typeOfSearch) {
  const methName = "findCountryIndexFromCountryId ";
  try{
    let countries = [];
    try { countries = JSON.parse(localStorage.getItem("countries")); }catch(err){;}
    if(countries===null || (typeof countries === "undefined")){
      return "";
    }
    if(typeOfSearch==="transfer"){ countries.countries = removeNonWuCountries(countries.countries); }
    console.log(methName+'ctry_wu_id='+ctry_wu_id+",lang="+lang+",countries.countries.length="+countries.countries.length);
    for(let i=0; countries.countries && i<countries.countries.length; ++i){
      if(countries.countries[i].ctry_wu_id===ctry_wu_id){
        if(lang==="en"){ return i;}
        else           { return i;}
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return 0;
}
//----------------------------------------------------------------------------------------------------
function findCurrencyNameFromCurrencyId(ctry_wu_id,lang) {

  let currencies = [];
  try { currencies = JSON.parse(localStorage.getItem("currencies")); }catch(err){;}
  if(currencies===null || (typeof currencies === "undefined")){
    return "";
  }
  console.log('ctry_wu_id='+ctry_wu_id+",lang="+lang+",currencies.countries.length="+currencies.countries.length);
  for(let i=0; currencies.countries && i<currencies.countries.length; ++i){
    if(currencies.countries[i].ctry_wu_id===ctry_wu_id){
      if(lang==="en"){ return currencies.countries[i]["descr_en"];}
      else           { return currencies.countries[i]["descr_el"];}
    }
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function findPhonePrefixNameFromPhonePrefixId(c2c_wu_id,lang) {

  let phonePrefixes = {};
  try { phonePrefixes = JSON.parse(localStorage.getItem("phonePrefixes")); }catch(err){;}
  if(phonePrefixes===null || (typeof phonePrefixes === "undefined")){
    return "";
  }
  console.log('c2c_wu_id='+c2c_wu_id+",lang="+lang+"phonePrefixes.phone_prefixes.length="+phonePrefixes.phone_prefixes.length);
  for(let i=0; phonePrefixes.phone_prefixes && i<phonePrefixes.phone_prefixes.length; ++i){
    if(phonePrefixes.phone_prefixes[i].c2c_wu_id===c2c_wu_id){
      if(lang==="en"){ return phonePrefixes.phone_prefixes[i]["descr"];}
      else           { return phonePrefixes.phone_prefixes[i]["descr"];}
    }
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function findPhonePrefixObjFromPhonePrefixId(c2c_wu_id,lang) {

  let phonePrefixes = {};
  try { phonePrefixes = JSON.parse(localStorage.getItem("phonePrefixes")); }catch(err){;}
  if(phonePrefixes===null || (typeof phonePrefixes === "undefined")){
    return {};
  }
  console.log('c2c_wu_id='+c2c_wu_id+",lang="+lang+"phonePrefixes.phone_prefixes.length="+phonePrefixes.phone_prefixes.length);
  for(let i=0; phonePrefixes.phone_prefixes && i<phonePrefixes.phone_prefixes.length; ++i){
    if(phonePrefixes.phone_prefixes[i].c2c_wu_id===c2c_wu_id){
      if(lang==="en"){ return phonePrefixes.phone_prefixes[i];}
      else           { return phonePrefixes.phone_prefixes[i];}
    }
  }
  return {};
}
//----------------------------------------------------------------------------------------------------
function findProfessionNameFromProfessionId(profession_wu_id,lang) {

  let userProfessionsv2 = {};
  try { userProfessionsv2 = JSON.parse(localStorage.getItem("userProfessionsv2")); }catch(err){;}
  if(userProfessionsv2===null || (typeof userProfessionsv2 === "undefined")){
    return "";
  }
  console.log('profession_wu_id='+profession_wu_id+",lang="+lang+",userProfessionsv2.professions.length="+userProfessionsv2.professions.length);
  for(let i=0; userProfessionsv2.professions && i<userProfessionsv2.professions.length; ++i){
    if(userProfessionsv2.professions[i]["profession_wu_id"]===profession_wu_id){
      if(lang==="en"){ return userProfessionsv2.professions[i]["descr_en"];}
      else           { return userProfessionsv2.professions[i]["descr_el"];}
    }
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function findPositionlevelNameFromPositionlevelId(position_wu_id,lang) {
  const methName = "findPositionlevelNameFromPositionlevelId ";
  try{
    let positionLevel = {};
    try { positionLevel = JSON.parse(localStorage.getItem("positionLevel")); }catch(err){;}
    if(positionLevel===null || (typeof positionLevel === "undefined")){
      return "";
    }
    console.log(methName+'position_wu_id='+position_wu_id+",lang="+lang+",positionLevel.positions.length="+positionLevel.positions.length);
    for(let i=0; positionLevel.positions && i<positionLevel.positions.length; ++i){
      if(positionLevel.positions[i]["position_wu_id"]===position_wu_id+""){
        if(lang==="en"){ return positionLevel.positions[i]["descr_en"];}
        else           { return positionLevel.positions[i]["descr_el"];}
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function findLanguageNameFromLanguageId(print_logs,lang_wu_id,lang) {
  const methName = "findLanguageNameFromLanguageId ";
  try{
    let countryLanguages = {};
    try { countryLanguages = JSON.parse(localStorage.getItem("countryLanguages")); }catch(err){;}
    if(countryLanguages===null || (typeof countryLanguages === "undefined")){
      return "";
    }
    if(print_logs){console.log(methName+'lang_wu_id='+lang_wu_id+",lang="+lang+",countryLanguages.languages.length="+countryLanguages.languages.length);}
    for(let i=0; countryLanguages.languages && i<countryLanguages.languages.length; ++i){
      if(countryLanguages.languages[i]["lang_wu_id"]===lang_wu_id+""){
        if(lang==="en"){ return countryLanguages.languages[i]["descr_en"];}
        else           { return countryLanguages.languages[i]["descr_el"];}
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function removeNonWuCountries(countries){
  let countriesNew = [];
  for(let i=0; i<countries.length; ++i){
    if(countries[i].isWu===true){countriesNew.push(countries[i]); /*console.log(countries[i].descr_en);*/}
  }
  //console.log('countriesNew.length='+countriesNew.length);
  if(countriesNew.length===0){return countries;}
  return countriesNew;
}
//----------------------------------------------------------------------------------------------------
function shouldForceRefreshAccessToken(){
  let accessToken_RetrieveLastDate = new Date(localStorage.getItem("accessToken_RetrieveLastDate"));
  let dateNow                      = new Date();
  if(accessToken_RetrieveLastDate===null){
      return false;
  }
  else{
      let secondsDiff = (dateNow.getTime()-accessToken_RetrieveLastDate.getTime())/1000;
      let minsDiff    = secondsDiff/60;
    //let hoursDiff   = (secondsDiff/60)/60;
      if(minsDiff<0){minsDiff = -minsDiff;}
      if(minsDiff>15-10){ console.log("[forceRefreshAccessToken=true]  minsDiff="+minsDiff); return true;  } //15 access Token TTL
      else              { console.log("[forceRefreshAccessToken=false] minsDiff="+minsDiff); return false; }
  }
}
//----------------------------------------------------------------------------------------------------
function normalizePhoneCountryName(phoneCountryName){
  const methName = "findCountryIdFromCountryName ";

  try{
    //phoneCountryName = phoneCountryName.replace("  " , " ")
    phoneCountryName = phoneCountryName.replace(/\([0-9]+\)/m,"").trim().toUpperCase();
    if(phoneCountryName.toUpperCase()==="ST. MARTIN")       { return "ST.MARTIN";}
    if(phoneCountryName.toUpperCase()==="AMERICAN SAMOA")   { return "AMERICAN  SAMOA";}
    if(phoneCountryName.toUpperCase()==="MARSHALL ISLANDS") { return "MARSHALL  ISLANDS";}
    return phoneCountryName;
  }catch(err){
    console.log(methName+'err='+err);
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function extractKeywordsFromJSON(arr, fields){
  const methName = "extractKeywordsFromJSON_sorted ";

  // var keywords_d = extractKeywordsFromJSON_unsorted_and_dupliates(arr, fields);
  // var keywords_U = keywords_d.filter(onlyUnique);///XXX
  // keywords_U = keywords_U.sort();
  // return keywords_U;

  try{
    var keywords_d = extractKeywordsFromJSON_unsorted_and_dupliates(arr, fields);
    for(let i=0; i<keywords_d.length; ++i){
      keywords_d[i] = replaceTonoumena(keywords_d[i].trim().toUpperCase());
    }
    keywords_d = keywords_d.filter(onlyUnique);
    return keywords_d.sort();
  }catch(err){
    console.log(methName+'err='+err);
  }
  return {};
}
//----------------------------------------------------------------------------------------------------
function replaceTonoumena(inputStr) {
  inputStr = inputStr.replace(/Ά/g,"Α");
  inputStr = inputStr.replace(/Έ/g,"Ε");
  inputStr = inputStr.replace(/Ή/g,"Η");
  inputStr = inputStr.replace(/Ί/g,"Ι");
  inputStr = inputStr.replace(/Ό/g,"Ο");
  inputStr = inputStr.replace(/Ύ/g,"Υ");
  inputStr = inputStr.replace(/Ώ/g,"Ω");
  return inputStr;
}
//----------------------------------------------------------------------------------------------------
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
//----------------------------------------------------------------------------------------------------
function extractKeywordsFromJSON_unsorted_and_dupliates(arr, fields){
  const methName = "extractKeywordsFromJSON ";

  try{
    return arr.reduce((acc, obj) => {
        fields.forEach(key => {
            if (obj[key] && acc.indexOf(obj[key])===-1) {
                acc.push(obj[key])
            }
        })
        return acc
    }, [])
  }catch(err){
    console.log(methName+'err='+err);
  }
  return [];
}
//----------------------------------------------------------------------------------------------------
function timetableFiltering(obj,timetableValue){
  let timetableEN = obj.timetableEN;
  if(timetableEN===null || (typeof timetableEN ==="undefined") || timetableEN===""){
    //console.log("timetableEN===null");
    return false;
  }

  try{
    let sun_mod_tue_wed_thu_fri_sat_isActive =  [false,false,false,false,false,false,false];
    let sun_mod_tue_wed_thu_fri_sat_hours    =  ["",   "",   "",   "",   "",   "",   ""];
    let timetableEN_arr = timetableEN.split(',');
    for(let i=0; i<timetableEN_arr.length; ++i){
      let days_arr  = timetableEN_arr[i].split(': ');
      let days_keys = days_arr[0].trim(); //console.log("days_keys="+days_keys); //Mon-Sat OR Mon-Sun OR Mon
      let days_vals = days_arr[1].trim(); //console.log("days_vals="+days_vals); //09:00 - 14:00;18:00 - 21:00 OR 09:00 - 14:00
      //---
      //Mon
      //---
      if(days_keys==="Mon"){
        sun_mod_tue_wed_thu_fri_sat_isActive[1]=true; sun_mod_tue_wed_thu_fri_sat_hours[1]=days_vals;//Mon
      }
      else if(days_keys==="Mon-Tue"){
        sun_mod_tue_wed_thu_fri_sat_isActive[1]=true; sun_mod_tue_wed_thu_fri_sat_hours[1]=days_vals;//Mon
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
      }
      else if(days_keys==="Mon-Wed"){
        sun_mod_tue_wed_thu_fri_sat_isActive[1]=true; sun_mod_tue_wed_thu_fri_sat_hours[1]=days_vals;//Mon
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
      }
      else if(days_keys==="Mon-Thu"){
        sun_mod_tue_wed_thu_fri_sat_isActive[1]=true; sun_mod_tue_wed_thu_fri_sat_hours[1]=days_vals;//Mon
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
      }
      else if(days_keys==="Mon-Fri"){
        sun_mod_tue_wed_thu_fri_sat_isActive[1]=true; sun_mod_tue_wed_thu_fri_sat_hours[1]=days_vals;//Mon
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
      }
      else if(days_keys==="Mon-Sat"){
        sun_mod_tue_wed_thu_fri_sat_isActive[1]=true; sun_mod_tue_wed_thu_fri_sat_hours[1]=days_vals;//Mon
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
      }
      else if(days_keys==="Mon-Sun"){
        sun_mod_tue_wed_thu_fri_sat_isActive[1]=true; sun_mod_tue_wed_thu_fri_sat_hours[1]=days_vals;//Mon
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
        sun_mod_tue_wed_thu_fri_sat_isActive[0]=true; sun_mod_tue_wed_thu_fri_sat_hours[0]=days_vals;//Sun
      }
      //---
      //Tue
      //---
      else if(days_keys==="Tue"){
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
      }
      else if(days_keys==="Tue-Wed"){
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
      }
      else if(days_keys==="Tue-Thu"){
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
      }
      else if(days_keys==="Tue-Fri"){
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
      }
      else if(days_keys==="Tue-Sat"){
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
      }
      else if(days_keys==="Tue-Sun"){
        sun_mod_tue_wed_thu_fri_sat_isActive[2]=true; sun_mod_tue_wed_thu_fri_sat_hours[2]=days_vals;//Tue
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
        sun_mod_tue_wed_thu_fri_sat_isActive[0]=true; sun_mod_tue_wed_thu_fri_sat_hours[0]=days_vals;//Sun
      }
      //---
      //Wed
      //---
      else if(days_keys==="Wed"){
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
      }
      else if(days_keys==="Wed-Thu"){
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
      }
      else if(days_keys==="Wed-Fri"){
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
      }
      else if(days_keys==="Wed-Sat"){
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
      }
      else if(days_keys==="Wed-Sun"){
        sun_mod_tue_wed_thu_fri_sat_isActive[3]=true; sun_mod_tue_wed_thu_fri_sat_hours[3]=days_vals;//Wed
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
        sun_mod_tue_wed_thu_fri_sat_isActive[0]=true; sun_mod_tue_wed_thu_fri_sat_hours[0]=days_vals;//Sun
      }
      //---
      //Thu
      //---
      else if(days_keys==="Thu"){
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
      }
      else if(days_keys==="Thu-Fri"){
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
      }
      else if(days_keys==="Thu-Sat"){
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
      }
      else if(days_keys==="Thu-Sun"){
        sun_mod_tue_wed_thu_fri_sat_isActive[4]=true; sun_mod_tue_wed_thu_fri_sat_hours[4]=days_vals;//Thu
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
        sun_mod_tue_wed_thu_fri_sat_isActive[0]=true; sun_mod_tue_wed_thu_fri_sat_hours[0]=days_vals;//Sun
      }
      //---
      //Fri
      //---
      else if(days_keys==="Fri"){
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
      }
      else if(days_keys==="Fri-Sat"){
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
      }
      else if(days_keys==="Fri-Sun"){
        sun_mod_tue_wed_thu_fri_sat_isActive[5]=true; sun_mod_tue_wed_thu_fri_sat_hours[5]=days_vals;//Fri
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
        sun_mod_tue_wed_thu_fri_sat_isActive[0]=true; sun_mod_tue_wed_thu_fri_sat_hours[0]=days_vals;//Sun
      }
      //---
      //Sat
      //---
      else if(days_keys==="Sat"){
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
      }
      else if(days_keys==="Sat-Sun"){
        sun_mod_tue_wed_thu_fri_sat_isActive[6]=true; sun_mod_tue_wed_thu_fri_sat_hours[6]=days_vals;//Sat
        sun_mod_tue_wed_thu_fri_sat_isActive[0]=true; sun_mod_tue_wed_thu_fri_sat_hours[0]=days_vals;//Sun
      }
      else if(days_keys==="Sun"){
        sun_mod_tue_wed_thu_fri_sat_isActive[0]=true; sun_mod_tue_wed_thu_fri_sat_hours[0]=days_vals;//Sun
      }
    }
    //for(let i=0; i<sun_mod_tue_wed_thu_fri_sat_isActive.length; ++i){
    // console.log("i="+i+",isActive="+sun_mod_tue_wed_thu_fri_sat_isActive[i]+",hours="+sun_mod_tue_wed_thu_fri_sat_hours[i]);
    //}
    if(timetableValue==="openNow"){
      let nowDate     = new Date();
      let nowDay      = nowDate.getDay();
      let nowHHMM_int = nowDate.getHours()*100 + nowDate.getMinutes();
      for(let i=0; i<sun_mod_tue_wed_thu_fri_sat_isActive.length; ++i){
        if(i===nowDay){
          if(sun_mod_tue_wed_thu_fri_sat_isActive[nowDay]===false){
            //console.log("OK nowDay="+nowDay+",sun_mod_tue_wed_thu_fri_sat_hours["+i+"]="+sun_mod_tue_wed_thu_fri_sat_hours[i]+",sun_mod_tue_wed_thu_fri_sat_isActive["+nowDay+"]="+sun_mod_tue_wed_thu_fri_sat_isActive[nowDay]);
            return false;
          }
          let storeRanges_arr = sun_mod_tue_wed_thu_fri_sat_hours[i].split(';'); //"09:00 - 14:00;18:00 - 21:00"->["09:00 - 14:00","18:00 - 21:00"]
          for(let j=0; j<storeRanges_arr.length; ++j){
            let storeStartEnd_arr = storeRanges_arr[j].split("-");
            let storeStart_int = convertTime2Int(storeStartEnd_arr[0].trim());//09:00->900
            let storeEnd_int   = convertTime2Int(storeStartEnd_arr[1].trim());//14:00->1400
            if(storeStart_int<nowHHMM_int && nowHHMM_int<storeEnd_int){
              //console.log("OK nowDay="+nowDay+",sun_mod_tue_wed_thu_fri_sat_hours["+i+"]="+sun_mod_tue_wed_thu_fri_sat_hours[i]+",sun_mod_tue_wed_thu_fri_sat_isActive["+nowDay+"]="+sun_mod_tue_wed_thu_fri_sat_isActive[nowDay]);
              return true;
            }
          }
        }
      }
    }
    else if(timetableValue==="openTodayAfternoon"){
      let nowDate     = new Date();
      let nowDay      = nowDate.getDay();
    //let nowHHMM_int = nowDate.getHours()*100 + nowDate.getMinutes();
      for(let i=0; i<sun_mod_tue_wed_thu_fri_sat_isActive.length; ++i){
        if(i===nowDay){
          if(sun_mod_tue_wed_thu_fri_sat_isActive[nowDay]===false){
            return false;
          }
          //console.log('timetableFiltering sun_mod_tue_wed_thu_fri_sat_hours[i]='+sun_mod_tue_wed_thu_fri_sat_hours[i]);
          let storeRanges_arr = sun_mod_tue_wed_thu_fri_sat_hours[i].split(';'); //"09:00 - 14:00;18:00 - 21:00"->["09:00 - 14:00","18:00 - 21:00"]
          for(let j=0; j<storeRanges_arr.length; ++j){
            let storeStartEnd_arr = storeRanges_arr[j].split("-");
            let storeStart_int = convertTime2Int(storeStartEnd_arr[0].trim());//09:00->900
            let storeEnd_int   = convertTime2Int(storeStartEnd_arr[1].trim());//14:00->1400
            //console.log('timetableFiltering storeStart_int='+storeStart_int+",storeEnd_int="+storeEnd_int);
            if(storeStart_int>=1700 || storeEnd_int>=1700){
              return true;
            }
          }
        }
      }
    }
    else if(timetableValue==="sunday")   { return sun_mod_tue_wed_thu_fri_sat_isActive[0]; }
    else if(timetableValue==="monday")   { return sun_mod_tue_wed_thu_fri_sat_isActive[1]; }
    else if(timetableValue==="tuesday")  { return sun_mod_tue_wed_thu_fri_sat_isActive[2]; }
    else if(timetableValue==="wednesday"){ return sun_mod_tue_wed_thu_fri_sat_isActive[3]; }
    else if(timetableValue==="thursday") { return sun_mod_tue_wed_thu_fri_sat_isActive[4]; }
    else if(timetableValue==="friday")   { return sun_mod_tue_wed_thu_fri_sat_isActive[5]; }
    else if(timetableValue==="saturday") { return sun_mod_tue_wed_thu_fri_sat_isActive[6]; }
  }catch(err){
    console.log("timetableFiltering err="+err+"-"+obj.timetableEN);
  }

  return false;
}
//----------------------------------------------------------------------------------------------------
function convertTime2Int(hhmm) {
  try{
    let hhmm_arr = hhmm.split(":");
    return parseInt(hhmm_arr[0])*100 + parseInt(hhmm_arr[1]);
  } catch(err){
    console.log("convertTime2Int err="+err);
  }
  return 0;
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function registration_telephone_get() {
  const methName = "registration_telephone_get ";

  let ws_phone = "";

  let parserObject_omtregistrationFull_req = [];
  try {
    parserObject_omtregistrationFull_req = JSON.parse(localStorage.getItem("parserObject_omtregistrationFull_req"));
  }catch(err1){console.log(methName+"err1="+err1);}
  try {
    ws_phone = parserObject_omtregistrationFull_req["telephone"];
  }catch(err2){console.log(methName+"err2="+err2);}
  if(ws_phone === null || (typeof ws_phone ==="undefined")){ws_phone = "";}

  if(ws_phone===""){
    ws_phone = localStorage.getItem("omtregistrationFull_req_telephone");
    if(ws_phone === null || (typeof ws_phone ==="undefined")){ws_phone = "";}
  }

  //nailed for testing:START---inactive
  //parserObject_omtregistrationFull_req = [];
  //parserObject_omtregistrationFull_req["telephone"] = "30-6932554149";
  //nailed for testing:END

  return ws_phone;
}
//----------------------------------------------------------------------------------------------------
function registration_telephone_set(ws_phone) {
  //const methName = "registration_telephone_set ";

  localStorage.setItem("omtregistrationFull_req_telephone",ws_phone);
}
//----------------------------------------------------------------------------------------------------
function findBankIdFromBankName(bank_name) {
  const methName = "findBankIdFromBankName ";
  try{
    let banks = [];
    try { banks = JSON.parse(localStorage.getItem("banks")); }catch(err){;}
    if(banks===null || (typeof banks === "undefined")){
      return "";
    }

    //console.log(methName+'bank_name='+bank_name+",banks.banks.length="+banks.banks.length);
    for(let i=0; banks.banks && i<banks.banks.length; ++i){
      if(banks.banks[i].name===bank_name){
        return banks.banks[i]["id"];
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
function findBankPhotoFromBankName(bank_name) {
  const methName = "findBankPhotoFromBankName ";
  try{
    let banks = [];
    try { banks = JSON.parse(localStorage.getItem("banks")); }catch(err){;}
    if(banks===null || (typeof banks === "undefined")){
      return "";
    }

    //console.log(methName+'bank_name='+bank_name+",banks.banks.length="+banks.banks.length);
    for(let i=0; banks.banks && i<banks.banks.length; ++i){
      if(banks.banks[i].name===bank_name){
        return banks.banks[i]["photo"];
      }
    }
  }catch(err){
    console.log(methName+'err='+err);
  }
  return "";
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function campaign_clear_statsView(campaign_enabled,campaign_prefix,campaign_cap_per_session,campaign_startDate,campaign_endDate,aViewName) {
  const methName = "campaign_clear_statsView ";

  aViewName = "payLinkWepApp";
  //------
  //checks
  //------
  if(campaign_enabled===false){
    console.log(methName+"campaign_enabled="+campaign_enabled);
    return;
  }
  if(campaign_active4Controllers.includes(aViewName)===false){
    console.log(methName+"campaign not enabled for="+aViewName);
    return;
  }
  try{
    var d0 = (new Date(campaign_startDate)).getTime();
    var d1 = (new Date(campaign_endDate)).getTime();
    var d2 = (new Date()).getTime();
    if(d2 < d0){ console.log(methName+"campaign not started="+campaign_startDate); return false; }
    if(d2 > d1){ console.log(methName+"campaign has expired="+campaign_endDate);   return; }
  } catch(err){
    console.log(methName+"err="+err);
  }
  //--------------
  //business logic
  //--------------
  var aView_flag      = campaign_prefix+"_"+aViewName+"_cnt";
  var aView_cnt_int   = 0;

  try{
    aView_cnt_int = 0;
    localStorage.setItem(aView_flag, aView_cnt_int.toString());
    console.log(methName+"aView_cnt_int="+aView_cnt_int+",campaign_cap_per_session="+campaign_cap_per_session);
  } catch(err){
    console.log(methName+"err="+err);
  }
  return;
}
//----------------------------------------------------------------------------------------------------
function campaign_should_show(campaign_enabled,campaign_prefix,campaign_cap_per_session,campaign_startDate,campaign_endDate,aViewName) {
  const methName = "campaign_should_show ";

  aViewName = "payLinkWepApp";
  //------
  //checks
  //------
  if(campaign_enabled===false){
    console.log(methName+"campaign_enabled="+campaign_enabled);
    return false;
  }
  if(campaign_active4Controllers.includes(aViewName)===false){
    console.log(methName+"campaign not enabled for="+aViewName);
    return;
  }
  try{
    var d0 = (new Date(campaign_startDate)).getTime();
    var d1 = (new Date(campaign_endDate)).getTime();
    var d2 = (new Date()).getTime();
    if(d2 < d0){ console.log(methName+"campaign not started="+campaign_startDate); return false; }
    if(d2 > d1){ console.log(methName+"campaign has expired="+campaign_endDate);   return false; }
  } catch(err){
    console.log(methName+"err="+err);
  }
  //--------------
  //business logic
  //--------------
  var aView_flag      = campaign_prefix+"_"+aViewName+"_cnt";
  var aView_cnt_str   = "";
  var aView_cnt_int   = 0;
  try { aView_cnt_str = JSON.parse(localStorage.getItem(aView_flag)); }catch(err){;}

  try{
    aView_cnt_int = (aView_cnt_str===null || (typeof aView_cnt_str === "undefined")) ? 0 : parseInt(aView_cnt_str);
    if(aView_cnt_int <= campaign_cap_per_session){
      console.log(methName+"aView_cnt_int="+aView_cnt_int+",campaign_cap_per_session="+campaign_cap_per_session);
      return true;
    }

  } catch(err){
    console.log(methName+"err="+err);
  }

  console.log(methName+"aView_cnt_int="+aView_cnt_int+",campaign_cap_per_session="+campaign_cap_per_session);
  return false;
}
//----------------------------------------------------------------------------------------------------
function campaign_record_load(campaign_enabled,campaign_prefix,campaign_cap_per_session,campaign_startDate,campaign_endDate,aViewName) {
  const methName = "campaign_record_load ";

  aViewName = "payLinkWepApp";
  //------
  //checks
  //------
  if(campaign_enabled===false){
    console.log(methName+"campaign_enabled="+campaign_enabled);
    return;
  }
  if(campaign_active4Controllers.includes(aViewName)===false){
    console.log(methName+"campaign not enabled for="+aViewName);
    return;
  }
  try{
    var d0 = (new Date(campaign_startDate)).getTime();
    var d1 = (new Date(campaign_endDate)).getTime();
    var d2 = (new Date()).getTime();
    if(d2 < d0){ console.log(methName+"campaign not started="+campaign_startDate); return false; }
    if(d2 > d1){ console.log(methName+"campaign has expired="+campaign_endDate);   return; }
  } catch(err){
    console.log(methName+"err="+err);
  }
  //--------------
  //business logic
  //--------------
  var aView_flag      = campaign_prefix+"_"+aViewName+"_cnt";
  var aView_cnt_str   = "";
  var aView_cnt_int   = 0;
  try { aView_cnt_str = JSON.parse(localStorage.getItem(aView_flag)); }catch(err){;}

  try{
    aView_cnt_int = (aView_cnt_str===null || (typeof aView_cnt_str === "undefined")) ? 0 : parseInt(aView_cnt_str);
    aView_cnt_int = aView_cnt_int + 1;
    localStorage.setItem(aView_flag, aView_cnt_int.toString());
    console.log(methName+"aView_cnt_int="+aView_cnt_int+",campaign_cap_per_session="+campaign_cap_per_session);
  } catch(err){
    console.log(methName+"err="+err);
  }
  return;
}
//----------------------------------------------------------------------------------------------------
function newRegistrationFlow_flag_get(print_logs,parserObject_validatecustomer) {
  let methName = "newRegistrationFlow_flag_get ";

  //newCustomer, changeId, annualUpdate, upgradeAccount

  var customerBeforeDateRegistered = false;
  var pendingDataConfirmation      = 0;
  var hasBP                        = false;
  var hasBP_null                   = true;
  var idVerificationStatus         = 0;
  var idVerificationStatus_null    = true;
  var isIdExpired                  = false;
  var hasCompletedGOV              = false;
  try {customerBeforeDateRegistered = parserObject_validatecustomer["customerBeforeDateRegistered"]; }catch(err){;} if(customerBeforeDateRegistered === null || (typeof customerBeforeDateRegistered === "undefined")){customerBeforeDateRegistered = false; }
  try {pendingDataConfirmation      = parserObject_validatecustomer["pendingDataConfirmation"];      }catch(err){;} if(pendingDataConfirmation      === null || (typeof customerBeforeDateRegistered === "undefined")){pendingDataConfirmation      = 0;     }
  try {hasBP                        = parserObject_validatecustomer["hasBP"];                        }catch(err){;} if(hasBP                        !== null && (typeof hasBP !== "undefined"))                       {hasBP_null                   = false; }
  try {idVerificationStatus         = parserObject_validatecustomer["idVerificationStatus"];         }catch(err){;} if(idVerificationStatus         !== null && (typeof idVerificationStatus !== "undefined"))        {idVerificationStatus_null    = false; }
  try {isIdExpired                  = parserObject_validatecustomer["idExpired"];                    }catch(err){;} if(isIdExpired                  === null || (typeof isIdExpired          === "undefined"))        {isIdExpired                  = false; }
  try {hasCompletedGOV              = parserObject_validatecustomer["hasCompletedGOV"];              }catch(err){;} if(hasCompletedGOV              === null || (typeof hasCompletedGOV      === "undefined"))        {hasCompletedGOV              = false; }
  if(print_logs){console.log(methName+"customerBeforeDateRegistered = "+customerBeforeDateRegistered);}
  if(print_logs){console.log(methName+"pendingDataConfirmation      = "+pendingDataConfirmation);}
  if(print_logs){console.log(methName+"hasBP                        = "+hasBP);}
  if(print_logs){console.log(methName+"hasBP_null                   = "+hasBP_null);}
  if(print_logs){console.log(methName+"idVerificationStatus         = "+idVerificationStatus);}
  if(print_logs){console.log(methName+"isIdExpired                  = "+isIdExpired);}
  if(print_logs){console.log(methName+"hasCompletedGOV              = "+hasCompletedGOV);}
  //customerBeforeDateRegistered => true(=before may2020), false(=after may 2020)
  //pendingDataConfirmation      => 0,1(=annual customer verification for WU)
  //hasBP                        => =null ,true(=Bill Payments user), false
  //idVerificationStatus         => =null(users registered before gov/idbox), 0(non verified), 1(verified), 2(changed id)
  //isIdExpired                  => true,false

  //nailed for testing:START---inactive
  // customerBeforeDateRegistered = false;
  // hasBP=false;
  // pendingDataConfirmation=0;
  // isIdExpired=false;
  // idVerificationStatus = null;
  // idVerificationStatus_null=true;
  //nailed for testing:END
  if(print_logs){console.log(methName+"CustomerWantedToLoginToBills = "+localStorage.getItem("CustomerWantedToLoginToBills"));}

                                                 //===============
                                                 //Before May 2020
                                                 //===============
  //------------------------------------------
  //Before 05/2020 && One year to Confirm Data------customerLevel=FULL------nextAction=CUSTOMER_CONFIRM
  //------------------------------------------
  if(customerBeforeDateRegistered === true && pendingDataConfirmation === 1){
      if(print_logs){console.log(methName+"GoTo_CustomerConfirm-1");}
      return {"screen":"CustomerConfirm", "flow":""};
  }
  //--------------------------------
  //Before 05/2020 && Id NOT Expired------customerLevel=FULL------nextAction=TRANSFER
  //--------------------------------
  else if(customerBeforeDateRegistered === true && pendingDataConfirmation === 0 && isIdExpired === false){
      if(localStorage.getItem("CustomerWantedToLoginToBills")==="true"){
        if(print_logs){console.log(methName+"GoTo_Bills-x1");}
        return {"screen":"Bills", "flow":""};
      }
      else{
        if(print_logs){console.log(methName+"[FULL][-]");}
        if(print_logs){console.log(methName+"GoTo_TransferOnline1-1");}
        return {"screen":"TransferOnline1", "flow":""};
      }
  }
  //---------------------------
  //Before 05/2020 & Id Expired------customerLevel=LIGHT------nextAction=CHANGE_ID
  //---------------------------
  else if(customerBeforeDateRegistered === true && pendingDataConfirmation === 0 && isIdExpired === true){
      if(print_logs){console.log(methName+"[LIGHT][changeId]");}
      if(print_logs){console.log(methName+"GoTo_RegisterInfo-1");}
      return {"screen":"RegisterInfo", "flow":"changeId"};
  }
                                                   //==============
                                                   //after May 2020
                                                   //==============
  //-----------------------------------------
  //after 05/2020 && One year to Confirm Data------customerLevel=UNKNOWN------nextAction=CUSTOMER_CONFIRM
  //-----------------------------------------
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 1){
      if(print_logs){console.log(methName+"GoTo_CustomerConfirm-2");}
      return {"screen":"CustomerConfirm", "flow":""};
  }
  //-------------------------------------------------------
  //after 05/2020 && Full registered Customer && Id Expired------customerLevel=LIGHT------nextAction=CHANGE_ID
  //-------------------------------------------------------
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === true){
      if(print_logs){console.log(methName+"GoTo_RegisterInfo-2");}
      return {"screen":"RegisterInfo", "flow":"changeId"};
  }
  //-----------------------------------------------------------
  //after 05/2020 && Full registered Customer && Id NOT Expired------customerLevel=FULL------nextAction=
  //-----------------------------------------------------------
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === false){
      if(localStorage.getItem("CustomerWantedToLoginToBills")==="true"){
        if(print_logs){console.log(methName+"GoTo_Bills-x2");}
        return {"screen":"Bills", "flow":""};
      }
      else{
        if(print_logs){console.log(methName+"GoTo_TransferOnline1-2");}
        return {"screen":"TransferOnline1", "flow":""};
      }
  }
  //-----------------------------------------------------
  //after 05/2020 && BP Customer && Customer NOT Verified------customerLevel=BP------nextAction=
  //-----------------------------------------------------
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && (idVerificationStatus === 0 || idVerificationStatus === 2 || idVerificationStatus_null === true)){
      if(print_logs){console.log(methName+"GoTo_Bills-1");}
      return {"screen":"Bills", "flow":""};
  }
  //---------------------------------------------------
  //after 05/2020 && not BP && One year to Confirm Data------customerLevel=UNKNOWN------nextAction=CUSTOMER_CONFIRM
  //---------------------------------------------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 1){
      if(print_logs){console.log(methName+"GoTo_CustomerConfirm-3");}
      return {"screen":"CustomerConfirm", "flow":""};
  }
  //-----------------------------------------------------------------------------
  //after 05/2020 && not BP && Customer registered BEFORE idBox && Id NOT Expired------customerLevel=FULL------nextAction=
  //-----------------------------------------------------------------------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus_null === true && isIdExpired === false){
    // if(localStorage.getItem("CustomerWantedToLoginToBills")==="true"){
    //   if(print_logs){console.log(methName+"GoTo_Bills-x3");}
    //   return {"screen":"Bills", "flow":""};
    // }
    // else{
    //   if(print_logs){console.log(methName+"GoTo_TransferOnline1-3");}
    //   return {"screen":"TransferOnline1", "flow":""};
    // }
    //13-06-2024
    if(print_logs){console.log(methName+"GoTo_RegisterInfo-2");}
    return {"screen":"RegisterInfo", "flow":"changeId"};
  }
  //-------------------------------------------------------------------------
  //after 05/2020 && not BP && Customer registered BEFORE idBox && expired Id------customerLevel=LIGHT------nextAction=CHANGE_ID
  //-------------------------------------------------------------------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus_null === true && isIdExpired === true){
      if(print_logs){console.log(methName+"GoTo_RegisterInfo-3");}
      return {"screen":"RegisterInfo", "flow":"changeId"};
  }
  //------------------------------------------------
  //after 05/2020 && not BP && Customer NOT verified------customerLevel=LIGHT------nextAction=NEW_CUSTOMER
  //------------------------------------------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 0){
      if(print_logs){console.log(methName+"GoTo_RegisterInfo-4");}
      return {"screen":"RegisterInfo", "flow":"newCustomer"};
  }
  //----------------------------------------------------------
  //after 05/2020 && not BP && Customer verified && expired Id------customerLevel=LIGHT------nextAction=CHANGE_ID
  //----------------------------------------------------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === true){
      if(print_logs){console.log(methName+"GoTo_RegisterInfo-5");}
      return {"screen":"RegisterInfo", "flow":"changeId"};
  }
  //--------------------------------------------------------------
  //after 05/2020 && not BP && Customer verified && Id NOT Expired------customerLevel=FULL------nextAction=
  //--------------------------------------------------------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === false){
      if(localStorage.getItem("CustomerWantedToLoginToBills")==="true"){
        if(print_logs){console.log(methName+"GoTo_Bills-x4");}
        return {"screen":"Bills", "flow":""};
      }
      else{
        if(print_logs){console.log(methName+"GoTo_TransferOnline1-4");}
        return {"screen":"TransferOnline1", "flow":""};
      }
  }
  //---------------------------------------------------
  //after 05/2020 && not BP && Customer changing his id------customerLevel=LIGHT------nextAction=CHANGE_ID
  //---------------------------------------------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 2){
      if(print_logs){console.log(methName+"GoTo_RegisterInfo-5");}
      return {"screen":"RegisterInfo", "flow":"changeId"};
  }

  if(print_logs){console.log(methName+"GoTo_TransferOnline1-5");}
  return {"screen":"TransferOnline1", "flow":""};
}
//----------------------------------------------------------------------------------------------------
function textDecisions_SettingsProfileId(print_logs,parserObject_validatecustomer) {
  let methName = "textDecisions_SettingsProfileId ";
  //console.log(methName);

  var customerBeforeDateRegistered = false;
  var pendingDataConfirmation      = 0;
  var hasBP                        = false;
  var hasBP_null                   = true;
  var idVerificationStatus         = 0;
  var idVerificationStatus_null    = true;
  var isIdExpired                  = false;
  var hasCompletedGOV              = false;
  try {customerBeforeDateRegistered = parserObject_validatecustomer["customerBeforeDateRegistered"]; }catch(err){;} if(customerBeforeDateRegistered === null || (typeof customerBeforeDateRegistered === "undefined")){customerBeforeDateRegistered = false; }
  try {pendingDataConfirmation      = parserObject_validatecustomer["pendingDataConfirmation"];      }catch(err){;} if(pendingDataConfirmation      === null || (typeof customerBeforeDateRegistered === "undefined")){pendingDataConfirmation      = 0;     }
  try {hasBP                        = parserObject_validatecustomer["hasBP"];                        }catch(err){;} if(hasBP                        !== null && (typeof hasBP !== "undefined"))                       {hasBP_null                   = false; }
  try {idVerificationStatus         = parserObject_validatecustomer["idVerificationStatus"];         }catch(err){;} if(idVerificationStatus         !== null && (typeof idVerificationStatus !== "undefined"))        {idVerificationStatus_null    = false; }
  try {isIdExpired                  = parserObject_validatecustomer["idExpired"];                    }catch(err){;} if(isIdExpired                  === null || (typeof isIdExpired          === "undefined"))        {isIdExpired                  = false; }
  try {hasCompletedGOV              = parserObject_validatecustomer["hasCompletedGOV"];              }catch(err){;} if(hasCompletedGOV              === null || (typeof hasCompletedGOV      === "undefined"))        {hasCompletedGOV              = false; }
  if(print_logs){console.log(methName+"customerBeforeDateRegistered = "+customerBeforeDateRegistered);}
  if(print_logs){console.log(methName+"pendingDataConfirmation      = "+pendingDataConfirmation);}
  if(print_logs){console.log(methName+"hasBP                        = "+hasBP);}
  if(print_logs){console.log(methName+"hasBP_null                   = "+hasBP_null);}
  if(print_logs){console.log(methName+"idVerificationStatus         = "+idVerificationStatus);}
  if(print_logs){console.log(methName+"isIdExpired                  = "+isIdExpired);}
  if(print_logs){console.log(methName+"hasCompletedGOV              = "+hasCompletedGOV);}
  //customerBeforeDateRegistered => true(=before may2020), false(=after may 2020)
  //pendingDataConfirmation      => 0,1(=annual customer verification for WU)
  //hasBP                        => =null ,true(=Bill Payments user), false
  //idVerificationStatus         => =null(users registered before gov/idbox), 0(non verified), 1(verified), 2(changed id)
  //isIdExpired                  => true,false

  //---------------
  //Before May 2020
  //---------------
  if(customerBeforeDateRegistered === true && pendingDataConfirmation === 1){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === true && pendingDataConfirmation === 1");}
      return "OK";
  }
  else if(customerBeforeDateRegistered === true && pendingDataConfirmation === 0 && isIdExpired === false){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === true && pendingDataConfirmation === 0 && isIdExpired === false");}
      return "OK";
  }
  else if(customerBeforeDateRegistered === true && pendingDataConfirmation === 0 && isIdExpired === true){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === true && pendingDataConfirmation === 0 && isIdExpired === true");}
      return "changeId";
  }
  //--------------
  //after 05/2020---Bill Payment=YES
  //--------------
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 1){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 1");}
      return "OK";
  }
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === true){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === true");}
      return "changeId";
  }
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === false){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === false");}
      return "OK";
  }
  else if(customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && (idVerificationStatus === 0 || idVerificationStatus === 2 || idVerificationStatus_null === true)){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && hasBP === true && pendingDataConfirmation === 0 && (idVerificationStatus === 0 || idVerificationStatus === 2 || idVerificationStatus_null === true");}
      return "OK";
  }
  //--------------
  //after 05/2020---Bill Payment=NO
  //--------------
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 1){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 1");}
      return "OK";
  }
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus_null === true && isIdExpired === false){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus_null === true && isIdExpired === false");}
      return "OK";
  }
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus_null === true && isIdExpired === true){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus_null === true && isIdExpired === true");}
      return "changeId";
  }
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 0){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 0");}
      return "newCustomer";
  }
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === true){
      if(print_logs){console.log(methName+" === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === true");}
      return "changeId";
  }
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === false){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 1 && isIdExpired === false");}
      return "OK";
  }
  else if(customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 2){
      if(print_logs){console.log(methName+"customerBeforeDateRegistered === false && (hasBP === false || hasBP_null === true) && pendingDataConfirmation === 0 && idVerificationStatus === 2");}
      return "changeId";
  }

  return "OK";
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
function textDecisions_customerLevel(print_logs,parserObject_validatecustomer) {
  let methName = "textDecisions_customerLevel ";
  //console.log(methName);

  var customerBeforeDateRegistered = false;
  var pendingDataConfirmation      = 0;
  var hasBP                        = false;
  var hasBP_null                   = true;
  var idVerificationStatus         = 0;
  var idVerificationStatus_null    = true;
  var isIdExpired                  = false;
  var hasCompletedGOV              = false;
  try {customerBeforeDateRegistered = parserObject_validatecustomer["customerBeforeDateRegistered"]; }catch(err){;} if(customerBeforeDateRegistered === null || (typeof customerBeforeDateRegistered === "undefined")){customerBeforeDateRegistered = false; }
  try {pendingDataConfirmation      = parserObject_validatecustomer["pendingDataConfirmation"];      }catch(err){;} if(pendingDataConfirmation      === null || (typeof customerBeforeDateRegistered === "undefined")){pendingDataConfirmation      = 0;     }
  try {hasBP                        = parserObject_validatecustomer["hasBP"];                        }catch(err){;} if(hasBP                        !== null && (typeof hasBP !== "undefined"))                       {hasBP_null                   = false; }
  try {idVerificationStatus         = parserObject_validatecustomer["idVerificationStatus"];         }catch(err){;} if(idVerificationStatus         !== null && (typeof idVerificationStatus !== "undefined"))        {idVerificationStatus_null    = false; }
  try {isIdExpired                  = parserObject_validatecustomer["idExpired"];                    }catch(err){;} if(isIdExpired                  === null || (typeof isIdExpired          === "undefined"))        {isIdExpired                  = false; }
  try {hasCompletedGOV              = parserObject_validatecustomer["hasCompletedGOV"];              }catch(err){;} if(hasCompletedGOV              === null || (typeof hasCompletedGOV      === "undefined"))        {hasCompletedGOV              = false; }
  if(print_logs){console.log(methName+"customerBeforeDateRegistered = "+customerBeforeDateRegistered);}
  if(print_logs){console.log(methName+"pendingDataConfirmation      = "+pendingDataConfirmation);}
  if(print_logs){console.log(methName+"hasBP                        = "+hasBP);}
  if(print_logs){console.log(methName+"hasBP_null                   = "+hasBP_null);}
  if(print_logs){console.log(methName+"idVerificationStatus         = "+idVerificationStatus);}
  if(print_logs){console.log(methName+"isIdExpired                  = "+isIdExpired);}
  if(print_logs){console.log(methName+"hasCompletedGOV              = "+hasCompletedGOV);}
  //customerBeforeDateRegistered => true(=before may2020), false(=after may 2020)
  //pendingDataConfirmation      => 0,1(=annual customer verification for WU)
  //hasBP                        => =null ,true(=Bill Payments user), false
  //idVerificationStatus         => =null(users registered before gov/idbox), 0(non verified), 1(verified), 2(changed id)
  //isIdExpired                  => true,false

  //nailed for testing:START---inactive
  //idVerificationStatus=1;
  //hasBP=false;
  //isIdExpired=true;
  //pendingDataConfirmation=1;
  //nailed for testing:END

  //---------------
  //Before May 2020
  //---------------
  if(customerBeforeDateRegistered === true){
      if(isIdExpired === false){ return "FULL";  }
      else                     { return "LIGHT"; }
  }
  //-----------------------------
  //After 05/2020 && Before IdBox
  //-----------------------------
  else if(customerBeforeDateRegistered === false && idVerificationStatus_null === true){
      if(isIdExpired === false){ return "FULL";  }
      else                     { return "LIGHT"; }
  }
  //----------------------------
  //After 05/2020 && After IdBox
  //----------------------------
  else if(idVerificationStatus === 1){
    if(isIdExpired === false){ return "FULL";  }
    else                     { return "LIGHT"; }
  }
  else if(idVerificationStatus !== 1 && hasBP === true){
      return "BP";
  }
  else{
      return "LIGHT";
  }
}
//----------------------------------------------------------------------------------------------------
function bills_normalizeAmount(resultInput) {
  //let methName = "bills_normalizeAmount ";

  var result = resultInput;

  let resultArr = result.split('.');
  if(resultArr.length === 1){
      result = result + ".00";
  }
  if(resultArr.length === 2){
      if(resultArr[1].length  >= 2){ result = resultArr[0] + "." + resultArr[1].substring(0, 2); }
      if(resultArr[1].length === 1){ result = resultArr[0] + "." + resultArr[1] + "0"; }
  }

  return result;
}
//----------------------------------------------------------------------------------------------------
function bills_amount_with_comma(resultInput) {
  //let methName = "bills_amount_with_comma ";

  var result = resultInput;
  result = result.replace(/\./g,",");
  return result;
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_status_text(status) {
  //let methName = "bills_status_text ";

       if(status === 82) { return "success"; }
  else if(status === 83) { return "success"; }
  else if(status === 84) { return "failure"; }
  else if(status === 90) { return "failure"; }
  else if(status === 97) { return "pending"; }
  else if(status === 89) { return "pending"; }//24/07/2023

  return "failure";
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_status_isDone(status){
  //let methName = "bills_status_isDone ";

       if(status === 82) { return true;  }
  else if(status === 83) { return true;  }
  else if(status === 84) { return false; }
  else if(status === 90) { return false; }
  else if(status === 97) { return false; }
  else if(status === 89) { return false; }

  return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_isRepeatable(billId,parserObject_categoriesCompaniesList) {
    //let methName = "bills_isRepeatable ";

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
        var ws_id      = 0;
        var repeatable = false;
       try {ws_id      = aItem["id"];         }catch(err){;} if(ws_id      === null || (typeof ws_id      ==="undefined")){ws_id      = 0;}
       try {repeatable = aItem["repeatable"]; }catch(err){;} if(repeatable === null || (typeof repeatable ==="undefined")){repeatable = false;}
        if(billId === ws_id){
            return repeatable;
        }
    }
    return false;
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_shouldBeInCategoriesListing(aItem) {
    //let methName = "bills_shouldBeInCategoriesListing ";

    //isActive===true  && IsExcluded===false PANTOU
    //isActive===true  && IsExcluded===true  MONO STO HISTORY
    //isActive===false                       MONO STO HISTORY

    var nameEl     = "";
    var nameEn     = "";
    var categoryEl = "";
    var categoryEn = "";
    var isActive   = false;
    var isExcluded = false;
    try {nameEl     = aItem["nameEl"];           }catch(err){;} if(nameEl     === null || (typeof nameEl     ==="undefined")){nameEl     = "";}
    try {nameEn     = aItem["nameEn"];           }catch(err){;} if(nameEn     === null || (typeof nameEn     ==="undefined")){nameEn     = "";}
    try {categoryEl = aItem["categoryEl"];       }catch(err){;} if(categoryEl === null || (typeof categoryEl ==="undefined")){categoryEl = "";}
    try {categoryEn = aItem["categoryEn"];       }catch(err){;} if(categoryEn === null || (typeof categoryEn ==="undefined")){categoryEn = "";}
    try {isActive   = aItem["isActive"];         }catch(err){;} //if(isActive   === null || (typeof isActive   ==="undefined")){isActive   = false;}
    try {isExcluded = aItem["isExcluded"];       }catch(err){;} //if(isExcluded === null || (typeof isExcluded ==="undefined")){isExcluded = false;}

    var debug_showLog = false;
    //if(nameEl==="ΕΠΙΜΕΛΗΤΗΡΙΟ ΑΧΑΙΑΣ"){ debug_showLog = true; }
    //if(nameEl==="ΕΥΔΑΠ"){return false;}

    if(isActive===false){
      if(debug_showLog){console.log("FALSE-1 aItem="+JSON.stringify(aItem)+",isActive="+isActive+",isExcluded="+isExcluded);}
      return false;
    }
    else{
      if(isExcluded===true){
        if(debug_showLog){console.log("FALSE-2 aItem="+JSON.stringify(aItem)+",isActive="+isActive+",isExcluded="+isExcluded);}
        return false;
      }
      else{
        if(debug_showLog){console.log("TRUE-1 aItem="+JSON.stringify(aItem)+",isActive="+isActive+",isExcluded="+isExcluded);}
        return true;
      }
    }
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_isTransactionFavorite_historyDetail(theObj) {

    var ws_isFavorite = false;
    try {ws_isFavorite = theObj["isFavorite"]; }catch(err){;} if(ws_isFavorite === null || (typeof ws_isFavorite ==="undefined")){ws_isFavorite = false;}

    return ws_isFavorite;
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_images_urls(billId,parserObject_categoriesCompaniesList){
    //let methName = "bills_images_urls ";

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
        var ws_id      = 0;
        var ws_logoUrl = "";
        try {ws_id      = aItem["id"];      }catch(err){;} if(ws_id      === null || (typeof ws_id      ==="undefined")){ws_id      = 0;}
        try {ws_logoUrl = aItem["logoUrl"]; }catch(err){;} if(ws_logoUrl === null || (typeof ws_logoUrl ==="undefined")){ws_logoUrl = "";}
        if(billId === ws_id){
            return ws_logoUrl;
        }
    }
    return "";
}
//-------------------------------------------------------------------------------------------------------------------------------
//2023-11-22 16:32:08.513
function bills_getFriendlyDate(aDate){
    //let methName = "bills_getFriendlyDate ";

    var retStr = "";
    if(aDate.length > 16){
        let Date2Arr = aDate.split(" ");
        var YMD_str:String = Date2Arr[0];
        let HMM_str:String = Date2Arr[1];

            YMD_str = YMD_str.substring(0,10);
        let dateArr = YMD_str.split("-")
        let YYYY_str = dateArr[0];
        let MMMM_str = dateArr[1];
        let DDDD_str = dateArr[2];

        var monthStr = "";
        if(localStorage.getItem("lang") === "el" ){
            if(MMMM_str === "01"){ monthStr = "Ιανουαρίου";  }
            if(MMMM_str === "02"){ monthStr = "Φεβρουαρίου"; }
            if(MMMM_str === "03"){ monthStr = "Μαρτίου";     }
            if(MMMM_str === "04"){ monthStr = "Απριλίου";    }
            if(MMMM_str === "05"){ monthStr = "Μαΐου";       }
            if(MMMM_str === "06"){ monthStr = "Ιουνίου";     }
            if(MMMM_str === "07"){ monthStr = "Ιουλίου";     }
            if(MMMM_str === "08"){ monthStr = "Αυγούστου";   }
            if(MMMM_str === "09"){ monthStr = "Σεπτεμβρίου"; }
            if(MMMM_str === "10"){ monthStr = "Οκτωβρίου";   }
            if(MMMM_str === "11"){ monthStr = "Νοεμβρίου";   }
            if(MMMM_str === "12"){ monthStr = "Δεκεμβρίου";  }
            retStr = DDDD_str + " " + monthStr + " " + YYYY_str + " " + HMM_str.substring(0,5);
        }
        else{
            if(MMMM_str === "01"){ monthStr = "January";   }
            if(MMMM_str === "02"){ monthStr = "February";  }
            if(MMMM_str === "03"){ monthStr = "March";     }
            if(MMMM_str === "04"){ monthStr = "April";     }
            if(MMMM_str === "05"){ monthStr = "May";       }
            if(MMMM_str === "06"){ monthStr = "June";      }
            if(MMMM_str === "07"){ monthStr = "July";      }
            if(MMMM_str === "08"){ monthStr = "August";    }
            if(MMMM_str === "09"){ monthStr = "September"; }
            if(MMMM_str === "10"){ monthStr = "October";   }
            if(MMMM_str === "11"){ monthStr = "November";  }
            if(MMMM_str === "12"){ monthStr = "December";  }
            retStr = monthStr + " " + DDDD_str + ", " + YYYY_str + " " + HMM_str.substring(0,5);
        }
        return retStr;
    }
    return aDate;
}
//----------------------------------------------------------------------------------------------------
function bills_companyNameFromBillId(billId,parserObject_categoriesCompaniesList){
    //let methName = "bills_companyNameFromBillId ";

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
        let aItem = parserObject_categoriesCompaniesList[i];
        var ws_id = 0;
        try {ws_id = aItem["id"]; }catch(err){;} if(ws_id === null || (typeof ws_id ==="undefined")){ws_id = 0;}
        //console.log(methName+"parserObject_categoriesCompaniesList.length="+parserObject_categoriesCompaniesList.length+" billId="+billId+" ws_id="+ws_id);
        if(billId === ws_id){
            var ws_nameEl = "";
            var ws_nameEn = "";
            try {ws_nameEl   = aItem["nameEl"]; }catch(err){;} if(ws_nameEl   === null || (typeof ws_nameEl   ==="undefined")){ws_nameEl   = "";}
            try {ws_nameEn   = aItem["nameEn"]; }catch(err){;} if(ws_nameEn   === null || (typeof ws_nameEn   ==="undefined")){ws_nameEn   = "";}
            if(localStorage.getItem("lang") === "el" && (ws_nameEl !== "")){ return ws_nameEl; }
            if(localStorage.getItem("lang") === "el" && (ws_nameEl === "")){ return ws_nameEn; }
            if(localStorage.getItem("lang") === "en" && (ws_nameEn !== "")){ return ws_nameEn; }
            if(localStorage.getItem("lang") === "en" && (ws_nameEn === "")){ return ws_nameEl; }
        }
    }
    return "";
}
//----------------------------------------------------------------------------------------------------
function bills_companyKeywordsFromBillId(billId,parserObject_categoriesCompaniesList){
    //let methName = "bills_companyKeywordsFromBillId ";

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
        let aItem = parserObject_categoriesCompaniesList[i];
        var ws_id = 0;
        try {ws_id = aItem["id"]; }catch(err){;} if(ws_id === null || (typeof ws_id ==="undefined")){ws_id = 0;}
        //console.log(methName+"parserObject_categoriesCompaniesList.length="+parserObject_categoriesCompaniesList.length+" billId="+billId+" ws_id="+ws_id);
        if(billId === ws_id){
            var ws_bpKeywords = "";
            try {ws_bpKeywords = aItem["bpKeywords"]; }catch(err){;} if(ws_bpKeywords === null || (typeof ws_bpKeywords ==="undefined")){ws_bpKeywords = "";}
            return ws_bpKeywords;
        }
    }
    return "";
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_companyObjectFromBillId(billId,parserObject_categoriesCompaniesList){
    //let methName = "bills_companyObjectFromBillId ";

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
        var ws_id = 0;
        try {ws_id = aItem["id"]; }catch(err){;} if(ws_id === null || (typeof ws_id ==="undefined")){ws_id = 0;}
        if(billId === ws_id){
            return aItem;
        }
    }
    return {};
}
//----------------------------------------------------------------------------------------------------
function bills_categoryExists(theItem,theList){
  //let methName = "bills_categoryExists ";

  let categoryFieldDescr = localStorage.getItem("lang")==="el" ? "categoryEl" : "categoryEn";

  var category = "";
  for(var i=0; i<theList.length; ++i){
      let aItem = theList[i];
      category = "";
      try {category   = aItem[categoryFieldDescr]; }catch(err){;} if(category   === null || (typeof category   ==="undefined")){category   = "";}
      if(theItem === category){
          //if(appDelegate.print_logs){print("\(theItem) ?? \(category)");}
          return true
      }
  }
  return false;
}

//-------------------------------------------------------------------------------------------------------------------------------
function bills_getPaymentAmount(){
    let methName = "bills_getPaymentAmount ";

    var parserObject_bills_payment_info_generic_aux = null;
    try{ parserObject_bills_payment_info_generic_aux = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_aux"));}catch(err){console.log(methName+'err='+err);}

    for(var i=0; i<parserObject_bills_payment_info_generic_aux.length; ++i){
        let item = parserObject_bills_payment_info_generic_aux[i];
        var ws_clientType = "";
        var ws_type       = "";
        var ws_value      = "";
        try{ ws_clientType = item["clientType"]; }catch (err){ ws_clientType = ""; }
        try{ ws_type       = item["type"];       }catch (err){ ws_type       = ""; }
        try{ ws_value      = item["value"];      }catch (err){ ws_value      = ""; }
        if(ws_clientType === "DOUBLE" && ws_type === "AMOUNT"){
            let theArr = ws_value.split(".");
            let theArr0_str = theArr[0];
            if(theArr.length === 2){
                let theArr1_str = theArr[1];
                //print("theArr1_str=\(theArr1_str) \(theArr1_str.count)");
                     if(theArr1_str.length >= 2) { ws_value = theArr0_str + "." + theArr1_str.substring(0, 2);; }
                else if(theArr1_str.length === 1){ ws_value = theArr0_str + "." + theArr1_str.substring(0,1) + "0"; }
                else                             { ws_value = theArr0_str + ".00"; }
                //let ws_value_f = Float(ws_value)!;
                //return (round(ws_value_f * 100) / 100.0);
                return parseFloat(ws_value);
            }
            else{
                ws_value = theArr0_str + ".00";
                let ws_value_f = parseFloat(ws_value);
                return (Math.round(ws_value_f * 100) / 100.0);
            }
        }
    }
    return parseFloat(0.0);
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_getPaymentFees(){
    let methName = "bills_getPaymentFees ";

    var parserObject_bills_payment_info_generic_aux = null;
    try{ parserObject_bills_payment_info_generic_aux = JSON.parse(localStorage.getItem("parserObject_bills_payment_info_generic_aux"));}catch(err){console.log(methName+'err='+err);}

    for(var i=0; i<parserObject_bills_payment_info_generic_aux.length; ++i){
        let item = parserObject_bills_payment_info_generic_aux[i];
        var ws_clientType = "";
        var ws_type       = "";
        var ws_value      = "";
        try{ ws_clientType = item["clientType"]; }catch (err){ ws_clientType = ""; }
        try{ ws_type       = item["type"];       }catch (err){ ws_type       = ""; }
        try{ ws_value      = item["value"];      }catch (err){ ws_value      = ""; }
        if(ws_clientType === "DOUBLE" && ws_type === "FEES"){
            let theArr = ws_value.split(".");
            let theArr0_str = theArr[0];
            if(theArr.length === 2){
                let theArr1_str = theArr[1];
                     if(theArr1_str.length  >= 2){ ws_value = theArr0_str + "." + theArr1_str.substring(0, 2);; }
                else if(theArr1_str.length === 1){ ws_value = theArr0_str + "." + theArr1_str.substring(0,1) + "0"; }
                else                             { ws_value = theArr0_str + ".00"; }
                //let ws_value_f = Float(ws_value)!;
                //return (round(ws_value_f * 100) / 100.0);
                return parseFloat(ws_value);
            }
            else{
                ws_value = theArr0_str + ".00";
                let ws_value_f = parseFloat(ws_value);
                return (Math.round(ws_value_f * 100) / 100.0);
            }
        }
    }
    return parseFloat(0.0);
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_history_getEndDate(){
    //let methName = "bills_history_getEndDate ";

    var date = new Date();
    var lastDay   = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    var lastDay_M = (lastDay.getMonth()+1).toString(); lastDay_M = lastDay_M.length===1 ? "0"+lastDay_M : lastDay_M;
    var lastDay_D = (lastDay.getDate()).toString();    lastDay_D = lastDay_D.length===1 ? "0"+lastDay_D : lastDay_D;
    return lastDay.getFullYear()+"-"+lastDay_M+"-"+lastDay_D;
}
//-------------------------------------------------------------------------------------------------------------------------------
function bills_history_getStartDate(){
    //let methName = "bills_history_getStartDate ";

    var date = new Date();
    var firstDay  = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setMonth(firstDay.getMonth() - 11);
    var firstDayy_M = firstDay.getMonth().toString(); firstDayy_M = firstDayy_M.length===1 ? "0"+firstDayy_M : firstDayy_M;
    var firstDayy_D = firstDay.getDate().toString();  firstDayy_D = firstDayy_D.length===1 ? "0"+firstDayy_D : firstDayy_D;
    if(firstDayy_M==="00"){firstDayy_M="01"}
    if(firstDayy_D==="00"){firstDayy_D="01"}
    return firstDay.getFullYear()+"-"+firstDayy_M+"-"+firstDayy_D;
}
//----------------------------------------------------------------------------------------------------
function triggerRefreshCheck(localStorage_key, localStorage_date, secondsCached) {
  //console.log("countries_RetrieveLastDate = "+new Date());
  //console.log("countries_RetrieveLastDate = "+localStorage.getItem("countries_RetrieveLastDate"));

  let UserWSRetrieveLastDate = new Date(localStorage.getItem(localStorage_date));
  let dateNow                = new Date();
  if(UserWSRetrieveLastDate===null){
      localStorage.setItem(localStorage_key,  "true");
      localStorage.setItem(localStorage_date, new Date());
      return true;
  }
  else{
      let secondsDiff = (dateNow.getTime()-UserWSRetrieveLastDate.getTime())/1000;
      if(secondsDiff<0){secondsDiff = -secondsDiff;}
      if(secondsDiff>secondsCached){
        localStorage.setItem(localStorage_key,  "true");
        localStorage.setItem(localStorage_date, new Date());
        return true;
      }
      else{
        return false;
      }
  }
}
//----------------------------------------------------------------------------------------------------
function addKeywordsToJSON_test(parserObject_list){
  //let methName = "addKeywordsToJSON_test ";
  //if(api.print_logs){console.log(methName);}

  return parserObject_list;

  // for(var i=0; i<parserObject_list.length; ++i){
  //   if(parserObject_list[i]["ctry_wu_id"]==="US"){parserObject_list[i]["keywords"]="USA";}
  //   if(parserObject_list[i]["ctry_wu_id"]==="GB"){parserObject_list[i]["keywords"]="UK"; }
  //   if(parserObject_list[i]["ctry_wu_id"]==="AE"){parserObject_list[i]["keywords"]="UAE";}
  // }
  // //console.log(methName+"parserObject_list="+JSON.stringify(parserObject_list));
  // return parserObject_list;
}
//----------------------------------------------------------------------------------------------------
function diffDatesSec(date1){
  //let methName = "diffDatesSec ";
  //if(api.print_logs){console.log(methName);}

  return parseFloat( ((new Date().getTime() - date1.getTime())/1000).toFixed(2) );
}
//----------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------
